import { useContext } from "react";
import { ThemeContext } from "styled-components";
import { getNumberFromPx } from "../../../../../../common-deprecated/themes/common";
import { useWindowDimensions } from "../../../../../../common-deprecated/hooks";
import type { CTAConfigType } from "../../../../../../common-deprecated/server/data/FormatBnbCtas";

// Small helper hook for determining which cta config should be used (desktop / mobile).
export const useCtaConfigTypes = (): keyof CTAConfigType => {
    const windowWidth = useWindowDimensions().width;
    const { breakpoints } = useContext(ThemeContext);
    return windowWidth && windowWidth < getNumberFromPx(breakpoints.md) ? "mobile" : "default";
};
